import { bebop as bebopApi } from 'core/api/definitions/bebop';

import { renderError as defaultRenderError } from 'core/utils/app-status-helper';
import {
  denormalizeData as defaultDenormalizeData,
  filterRequiredParams,
} from 'core/utils/api';
import { throwIfHistoryIsMissing } from 'core/utils/query';


export const topicsQuery = (queryParams, config) => {
  throwIfHistoryIsMissing(queryParams, 'topicsQuery in topics.js');

  const {
    include: outerInclude,
    fields: outerFields,
    renderError = defaultRenderError,
    history,
    ...getParams // TODO: 11158 здесь в запрос могут попадать ненужные параметры
  } = queryParams;

  const include = outerInclude || filterRequiredParams(getParams, 'include');
  const fields = outerFields || filterRequiredParams(getParams, 'fields');

  return {
    ...config,
    queryKey: ['bebopApi', 'getTopics', { ...getParams, include, fields }],
    queryFn: ({ queryKey: [, method, params] }) => bebopApi[method](params).catch(err => renderError(err, history)),
    select: config?.select || defaultDenormalizeData,
  };
};
